/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Overwrite_LocaleInputs */

const cs_property_ai_overwrite_locale = /** @type {(inputs: Property_Ai_Overwrite_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přepsat existující text v tomto jazyce`)
};

const en_property_ai_overwrite_locale = /** @type {(inputs: Property_Ai_Overwrite_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overwrite existing text in this language`)
};

/**
* | output |
* | --- |
* | "Overwrite existing text in this language" |
*
* @param {Property_Ai_Overwrite_LocaleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_overwrite_locale = /** @type {((inputs?: Property_Ai_Overwrite_LocaleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Overwrite_LocaleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_overwrite_locale(inputs)
	return cs_property_ai_overwrite_locale(inputs)
});